export const observable = Symbol.observable || "@@observable";
//# sourceMappingURL=symbols.js.map